import { observable, computed, action, toJS } from 'mobx';

import Services from '@services/index';
import Store from './Store';
import { RadioReceipt } from '@core/constants/radioButtons';

interface SuccessModal {
  isOpen: boolean;
  case: RadioReceipt;
}

class ChangeEmailStore extends Store {
  @observable private _isModalOpen: boolean;
  @observable private _isGeneralTabOpen: boolean;
  @observable private _isNotificationsTabOpen: boolean;
  @observable private _isAccountTabOpen: boolean;
  @observable private _successModal: SuccessModal;

  public constructor(services: Services) {
    super(services);

    this._isModalOpen = false;
    this._isGeneralTabOpen = false;
    this._isNotificationsTabOpen = false;
    this._isAccountTabOpen = false;
    this._successModal = {
      isOpen: false,
      case: undefined,
    };
  }

  @action public setModalState = (isModalOpen: boolean): void => {
    this._isModalOpen = isModalOpen;
  };

  @action public setGeneralTabState = (isGeneralTabOpen: boolean): void => {
    this._isGeneralTabOpen = isGeneralTabOpen;
  };

  @action public setNotificationsTabState = (isNotificationsTabOpen: boolean): void => {
    this._isNotificationsTabOpen = isNotificationsTabOpen;
  };

  @action public setSuccessModal = (value: SuccessModal): void => {
    this._successModal = value;
  };

  @action public setAccountTabOpen = (value: boolean): void => {
    this._isAccountTabOpen = value;
  };

  @computed public get modalState(): boolean {
    return toJS(this._isModalOpen);
  }

  @computed public get isGeneralTabOpen(): boolean {
    return toJS(this._isGeneralTabOpen);
  }

  @computed public get isNotificationsTabOpen(): boolean {
    return toJS(this._isNotificationsTabOpen);
  }

  @computed public get successModal(): SuccessModal {
    return toJS(this._successModal);
  }

  @computed public get isAccountTabOpen(): boolean {
    return toJS(this._isAccountTabOpen);
  }
}
export default ChangeEmailStore;
